import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IInventoryLocation } from '@inventory/models/inventory';
import { IInventoryLocationEditForm } from '@inventory/models/inventory-forms';
import { InventoryLocationsService } from '@inventory/services/inventory-locations/inventory-locations.service';
import { StandardControlComponent } from '@shared/components/forms/standard-control/standard-control.component';
import { SwitchControlComponent } from '@shared/components/forms/switch-control/switch-control.component';
import { TextareaControlComponent } from '@shared/components/forms/textarea-control/textarea-control.component';
import { ToastTypes } from '@shared/models/toast';
import { OffcanvasService } from '@shared/services/offcanvas/offcanvas.service';
import { ToastService } from '@shared/services/toast/toast.service';

@Component({
	selector: 'app-inventory-location-details-offcanvas',
	imports: [CommonModule, StandardControlComponent, TextareaControlComponent, SwitchControlComponent],
	templateUrl: './inventory-location-details-offcanvas.component.html',
	styleUrl: './inventory-location-details-offcanvas.component.scss',
	host: {
		class: 'h-100',
		style: 'display: contents',
	},
})
export class InventoryLocationDetailsOffcanvasComponent implements OnInit {
	@Input() inventoryLocation: IInventoryLocation;

	private inventoryLocationsService = inject(InventoryLocationsService);
	private offcanvasService = inject(OffcanvasService);
	private toastService = inject(ToastService);

	form: FormGroup<IInventoryLocationEditForm>;

	isSubmitting: boolean = false;

	ngOnInit(): void {
		this.form = new FormGroup<IInventoryLocationEditForm>({
			name: new FormControl<string | null>(null, [Validators.required, Validators.minLength(2), Validators.maxLength(100)]),
			description: new FormControl<string | null>(null, [Validators.maxLength(500)]),
			archived: new FormControl<boolean | null>(false),
		});

		this.form.setValue({
			name: this.inventoryLocation.name,
			description: this.inventoryLocation.description,
			archived: this.inventoryLocation.archived,
		});
	}

	close(): void {
		this.offcanvasService.dismissLast();
	}

	submit(): void {
		if (this.form.invalid) {
			return;
		}

		this.isSubmitting = true;

		this.inventoryLocationsService
			.updateInventoryLocation(this.inventoryLocation.id as string, this.form)
			.then(() => {
				this.isSubmitting = false;
				this.offcanvasService.dismissLast();
			})
			.catch((error) => {
				console.error('Error updating inventory location:', error);
				this.isSubmitting = false;
				this.toastService.showToast({
					title: 'Inventory Location',
					message: `Failed to update inventory location: ${error.message}`,
					type: ToastTypes.ERROR,
				});
			});
	}
}
